module.exports = __webpack_public_path__ + "static/media/female.cecd8512.svg";